import type {
  Flow_AbstractComponent,
  Flow_Diff,
  Flow_ComponentProps,
  Flow_ObjMap,
} from 'src/types/flow-to-typescript-codemod';
import type {Params, RouterHistory, RerouterLocation} from 'src/rerouter/index';
import * as React from 'react';
import {useHistory, useParams} from 'src/rerouter/index';
import hoistNonReactStatics from 'hoist-non-react-statics';

import nameHoc from './nameHoc';

/**
 * DO NOT USE THIS.
 * This is a legacy HOC for backwards compatibility.
 */
export function withRouter<C>(
  WrappedComponent: React.ComponentType<C>,
): React.ComponentType<
  Flow_Diff<
    // @ts-expect-error - TS2344 - Type 'C' does not satisfy the constraint '{ router: BaseHistory; location: RerouterLocation; params: Readonly<{ [key: string]: string; }>; }'.
    C,
    {
      router: RouterHistory;
      location: RerouterLocation;
      params: Params;
    }
  >
> {
  return nameHoc(
    // @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
    hoistNonReactStatics((props) => {
      const history = useHistory();
      const params = useParams();
      return (
        <WrappedComponent
          {...props}
          router={history}
          location={history.location}
          params={params}
        />
      );
    }, WrappedComponent),
    WrappedComponent,
    'withRouter',
  );
}

export function withHistory<C>(
  WrappedComponent: React.ComponentType<C>,
): React.ComponentType<
  Flow_Diff<
    // @ts-expect-error - TS2344 - Type 'C' does not satisfy the constraint '{ router: BaseHistory; history: BaseHistory; location: RerouterLocation; }'.
    C,
    {
      router: RouterHistory;
      history: RouterHistory;
      location: RerouterLocation;
    }
  >
> {
  return nameHoc(
    // @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
    hoistNonReactStatics((props) => {
      const history = useHistory();
      return (
        <WrappedComponent
          {...props}
          router={history}
          history={history}
          location={history.location}
        />
      );
    }, WrappedComponent),
    WrappedComponent,
    'withHistory',
  );
}

/*
export function useRouter() {
  const history = useHistory();
  const params = useParams();
  const {location} = history;

  const router = React.useMemo(() => ({
    push: (...args) => history.push(...args),
    replace: (...args) => history.replace(...args),
    goBack: () => history.back(),
  }), [history]);

  return {
    ...router,
    router,
    history,
    params,
    location,
  };
}
*/
